/**
 * Gemeinsame Typen der Gespraech-Karte und des Mail-Fensters (docs/KONZEPT-GESPRAECH-MAILFENSTER.md).
 * Eigene Datei, damit `GespraechMailfenster` und Teile nicht aus der Karte importieren muessen,
 * die sie selbst einbindet.
 */
import type { MailEreignis } from "../format";

export interface InquiryTranslation {
  lang: string;
  textDe: string | null;
  model: string;
  createdAt: string;
}

export interface GespraechAttachment {
  filename: string | null;
  mimeType: string;
  sizeBytes: number;
}

/** ID der synthetischen Gast-Nachricht (Formular-/Freitext-Anfrage ohne echte E-Mail) — existiert
 *  nicht in `emails`, deshalb nie zuordenbar und nie Ziel von „Zitat anhaengen“. */
export const SYNTHETISCHE_NACHRICHT_ID = "__anfrage__";

/** Volle Mail-Zeile (`GET /api/events/:id/emails`, `SELECT *` + `ereignisse` + seit dem Mail-Fenster
 *  `art`/`empfaenger`/`zusammengefassteIds` vom Server). */
export interface GespraechEmailRow {
  id: string;
  direction: "inbound" | "outbound";
  fromAddr: string;
  toAddr: string | null;
  subject: string | null;
  bodyText: string | null;
  bodyHtml?: string | null;
  status: string | null;
  error: string | null;
  aiClassification: string | null;
  receivedAt: string;
  createdAt?: string | null;
  rawHeaders?: unknown;
  attachmentsManifest?: GespraechAttachment[] | null;
  ereignisse?: MailEreignis[];
  /** WhatsApp-Kennzeichen — die Route liefert das Feld ohnehin (`SELECT *`). */
  channel?: "email" | "whatsapp";
  /** NULL = ungelesen (Migration 321); `undefined` = unbekannt (Tests, synthetische Zeile). */
  readAt?: string | null;
  /** Server-Einteilung: Gespraech mit dem Gast oder Hinweis an den Betrieb. Fehlt sie, zaehlt die
   *  Zeile als Gast-Gespraech. */
  art?: "gast" | "betrieb";
  /** Alle Empfaenger (bei zusammengefassten Betriebshinweisen mehrere). */
  empfaenger?: string[];
  zusammengefassteIds?: string[];
}
